import React, { useMemo } from "react";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the Data Grid

import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import i18next from "i18next";

import { BSCoreServicesDtoMarketplaceBonusOnInvoiceProductDetailDto } from "api/reactQuery/querySchemas";
import {
  COLUMN_TYPE_NAMES,
  getGridDefaultProps,
} from "constants/agGridConstants";

type Props = {
  bonusOnInvoiceData: BSCoreServicesDtoMarketplaceBonusOnInvoiceProductDetailDto[];
};

const BonusOnInvoiceTable = ({ bonusOnInvoiceData }: Props) => {
  const colDefs = useMemo<
    ColDef<BSCoreServicesDtoMarketplaceBonusOnInvoiceProductDetailDto>[]
  >(
    () => [
      {
        field: "importDate",
        headerName: i18next.t("bonus_oninvoice_table_import"),
        type: COLUMN_TYPE_NAMES.DATE_COLUMN,
      },
      {
        field: "productName",
        headerName: i18next.t("bonus_oninvoice_table_product"),
        valueFormatter: (params) => {
          if (params.value === "no products available") {
            return i18next.t("bonus_oninvoice_table_no_products");
          }
        },
      },
      {
        field: "importedBonusQuantity",
        headerName: i18next.t("bonus_oninvoice_table_bonus_quantity"),
      },
      {
        field: "remainingBonusQuantity",
        headerName: i18next.t("bonus_oninvoice_table_remaining_quantity"),
      },
      {
        field: "bonusPrice",
        headerName: i18next.t("bonus_oninvoice_table_price_without_VAT"),
      },
    ],
    []
  );

  if (!bonusOnInvoiceData) {
    return null;
  }

  return (
    <div style={{ height: 130, marginBottom: 80, marginTop: 30 }}>
      <h1 style={{ fontSize: 30 }}>{i18next.t("bonus_oninvoice")}</h1>
      <AgGridReact
        rowData={bonusOnInvoiceData}
        columnDefs={colDefs}
        {...getGridDefaultProps()}
      />
    </div>
  );
};

export default BonusOnInvoiceTable;
